import { AddRounded, EditRounded } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, Divider, IconButton, Stack, Typography } from "@mui/material";
import { allShootspath, allStylesPath, attrGrpTableStrColumnsObj } from "components/PimDashboard/data";
import { fileColumns, shootFileAssocObj, shootImagesAssocObj, shootModalProfileAssoc, shootUrlKey } from "../CreateShoot/data";
import { AuthState } from "context/AuthContext";
import { getRelProtectedFileSignedUrl } from "data/globalData";
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import ImageSlider from "components/PimDashboard/CommonComponents/ImageSlider/ImageSlider";
import AddNewImageModal from "./AddNewImageModal/AddNewImageModal";
import { GlobalState } from "context/GlobalContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { styleImgDepartmentCol } from "components/PimDashboard/DashboardComponents/Designer/CreateStyle/data";

import DisplayDetailsWithEditTab from "./DisplayDetailsWithEditTab/DisplayDetailsWithEditTab";
import EditImageDataModal from "./EditImageDataModal/EditImageDataModal";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { custom, departments } from "data/authData";
import AddFiles, { fileColumn } from "components/PimDashboard/CommonComponents/AddFiles/AddFiles";
import { studioAttrGrpAttrAssocObj } from "../StudioAttributes/data";
import { StudioDashboardState } from "context/StudioDashboardContext";
import { studioAttrGroupLinkedTables } from "../StudioAttributeGroups/data";
import { dummySelectedShootData } from "./data";
import ShootSkuImages from "./ShootSkuImages/ShootSkuImages";
import ModalSection from "../CreateShoot/ModalSection/ModalSection";
import { set } from "lodash";
import SkuSectionTanstack from "../CreateShoot/SkuSection/SkuSectionTanstack";
import { sampleStatusColumn } from "../ShootsDashboard/data";
import { statusOptions } from "data/globalData";
const imgWidth = 220;
const imgHeight = 300;
const selectedShootVisibleStatus = statusOptions.RECEIVED.key;

const SelectedShoot = () => {
	const { user } = AuthState();
	const { setSnackBar, setSnackBarOpen, snackBar, setLoadingOpen, Loadingopen } = GlobalState();
	const { setSelectedShoot, selectedShoot, attrGroupsWithAttr } = StudioDashboardState();

	const [selectedShootSkus, setSelectedShootSkus] = useState([]);
	const [hasResolvedShoot, setHasResolvedShoot] = useState(false);
	let [searchParams, setSearchParams] = useSearchParams();
	const shootId = useMemo(() => searchParams.get(shootUrlKey), [searchParams]);

	const disableEdit = user?.role?.[custom.SHOOT_VIEWER.key] === true;
	useEffect(() => {
		const fetchShootData = async () => {
			if (!shootId) {
				setSelectedShoot(null);
				setSelectedShootSkus([]);
				setHasResolvedShoot(true);
				return;
			}

			setLoadingOpen(true);
			setHasResolvedShoot(false);
			try {
				const [shootRes, skusRes] = await Promise.all([
					axios.get(`/api/studio/shoot_by_id/${shootId}`),
					axios.get(`/api/studio/shoot_skus_by_shoot_id/${shootId}`),
				]);
				setSelectedShoot(shootRes.data.result);
				setSelectedShootSkus(skusRes.data.result ?? []);
				setHasResolvedShoot(true);
				setLoadingOpen(false);
			} catch (error) {
				setSelectedShoot(null);
				setSelectedShootSkus([]);
				setHasResolvedShoot(true);
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
				setLoadingOpen(false);
			}
		};
		fetchShootData();
	}, [shootId]);

	const navigate = useNavigate();

	const [addNewImgModal, setAddNewImgModal] = useState(false);
	const [imgInfoModal, setImgInfoModal] = useState(false);
	const [modalProfileEditModal, setModalProfileEditModal] = useState(false);
	const [skuAddModal, setSkuAddModal] = useState(false);
	const [newSkus, setNewSkus] = useState([]);
	const [editedModelProfile, setEditedModelProfile] = useState(false);

	const handleModalprofileEditModalOpen = () => {
		setModalProfileEditModal(true);
	};

	const handleModalprofileEditModalClose = () => {
		setModalProfileEditModal(false);
	};
	const handleSkuAddModalOpen = () => {
		setSkuAddModal(true);
	};
	const handleSkuAddModalClose = () => {
		setSkuAddModal(false);
	};

	const handleImagesUpload = async (files, data) => {
		const formData = new FormData();
		for (let i = 0; i < files.length; i++) {
			formData.append(shootImagesAssocObj, files[i].file);
		}
		formData.append("shoot_id", data?.[studioAttrGroupLinkedTables.shoot.key]?.shoot_id);
		return await axios
			.post("/api/studio/upload_shoot_images", formData, {
				headers: {
					"content-type": "multipart/form-data",
				},
			})
			.then((res) => {
				return res.data.result;
			})
			.catch((err) => {
				return parseErrorMessage(err);
			});
	};
	const handleFileAdd = async (newFileData) => {
		const formData = new FormData();
		formData.append("file", newFileData[fileColumn.key]);
		formData.append("fileMeta", JSON.stringify(newFileData));

		const uploadToBucket = await axios.post("/api/upload/single_upload_to_rel_bucket", formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});

		const res = await axios.post("/api/studio/create_shoot_file_sql", {
			...uploadToBucket.data.result,
			shoot_id: selectedShoot[studioAttrGroupLinkedTables.shoot.key].shoot_id,
		});
		setSelectedShoot((prev) => ({
			...prev,
			[studioAttrGroupLinkedTables?.shoot.key]: {
				...prev?.[studioAttrGroupLinkedTables.shoot.key],
				[shootFileAssocObj]: [...prev?.[studioAttrGroupLinkedTables.shoot.key][shootFileAssocObj], res.data.result],
			},
		}));
		return true;
	};
	const handleFileDelete = async (newFileData) => {
		const formData = new FormData();
		formData.append("file", newFileData[fileColumn.key]);
		formData.append("fileMeta", newFileData);
		setLoadingOpen(true);
		try {
			const res = await axios.delete(`/api/studio/delete_modal_profile_file_sql/${newFileData.id}`);
			if (res) {
				setSelectedShoot((prev) => ({
					...prev,
					[studioAttrGroupLinkedTables?.modal_profile.key]: {
						...prev?.[studioAttrGroupLinkedTables.shoot.key],
						[shootFileAssocObj]: prev?.[studioAttrGroupLinkedTables.shoot.key][shootFileAssocObj]?.filter(
							(row) => row?.id != newFileData.id
						),
					},
				}));
				setLoadingOpen(false);
				return true;
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
			return false;
		}
		return true;
	};

	const handleFileDownload = async (row) => {
		{
			try {
				setLoadingOpen(true);
				const fileUrl = await getRelProtectedFileSignedUrl(row?.url);
				if (fileUrl) {
					window.open(fileUrl, "_blank");
					setSnackBarOpen(true);
					setSnackBar({ ...snackBar, message: "File Downloaded Successfully", severity: "success" });
					setLoadingOpen(false);
				}
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error), severity: "error" });
				setLoadingOpen(false);
			}
		}
	};
	const updateMainImage = async (data) => {
		setLoadingOpen(true);
		try {
			const res = await axios.put("/api/studio/change_shoot_main_image", data);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Main Image Changed Sucessfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
				res,
			});
			if (res)
				setSelectedShoot((prev) => ({
					...prev,
					[studioAttrGroupLinkedTables.shoot.key]: {
						...prev[studioAttrGroupLinkedTables.shoot.key],
						[shootImagesAssocObj]: prev[studioAttrGroupLinkedTables.shoot.key][shootImagesAssocObj]?.map((row) => {
							if (row.id === data.id) return { ...row, is_main: true };
							else return { ...row, is_main: false };
						}),
					},
				}));
			setLoadingOpen(false);
			setImgInfoModal(false);
			return true;
		} catch (error) {
			console.log(error);
			setLoadingOpen(false);

			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			return false;
		}
	};
	const addNewImages = async (images, mainImgIndex) => {
		setLoadingOpen(true);

		const imageUrls = await handleImagesUpload(images, selectedShoot);

		const productImages = imageUrls.map((row, index) => {
			return {
				shoot_id: selectedShoot?.[studioAttrGroupLinkedTables.shoot.key]?.shoot_id,
				is_main: false,
				url: row.publicUrl,
			};
		});

		try {
			const res = await axios.post("/api/studio/bulk_create_shoot_images_sql", productImages);

			setSelectedShoot({
				...selectedShoot,
				[studioAttrGroupLinkedTables.shoot.key]: {
					...selectedShoot[studioAttrGroupLinkedTables.shoot.key],
					[shootImagesAssocObj]: [
						...selectedShoot[studioAttrGroupLinkedTables.shoot.key][shootImagesAssocObj],
						...res.data.result,
					],
				},
			});
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Images created Successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
				res,
			});
			setLoadingOpen(false);

			return true;
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
			return false;
		}
	};

	const goToShootsPage = () => {
		navigate(`/${allShootspath}`);
	};

	const updateDetailsFun = async (data, modelCloseFun, attrGrp) => {
		if (data) {
			try {
				const res = await axios.put(
					`/api/studio/update_shoot_data/${attrGrp?.linked_table}?group_id=${attrGrp?.group_id}`,
					data
				);

				setSelectedShoot({
					...selectedShoot,
					[attrGrp.linked_table]: data,
					res,
				});
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Data saved successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
					res,
				});
				modelCloseFun();
			} catch (error) {
				console.log(error, "hgfghrdfdggggggghjk");
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			}
		}
	};
	const handleUpdateModalProfileSave = async () => {
		try {
			setLoadingOpen(true);
			if (!editedModelProfile) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: "Please select a modal profile", severity: "error" });
				setLoadingOpen(false);
				return;
			}

			await axios
				.put(`/api/studio/update_shoot_modal_profile/${selectedShoot[studioAttrGroupLinkedTables.shoot.key].shoot_id}`, {
					modal_profile_id: editedModelProfile.modal_profile_id,
				})
				.then((res) => {
					setSelectedShoot({
						...selectedShoot,
						[studioAttrGroupLinkedTables.shoot.key]: {
							...selectedShoot[studioAttrGroupLinkedTables.shoot.key],
							[shootModalProfileAssoc]: editedModelProfile,
						},
					});
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "Modal Profile Updated Successfully",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				});
			setLoadingOpen(false);
			handleModalprofileEditModalClose();
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};
	const handleSkuAddSkuModalSave = async () => {
		try {
			setLoadingOpen(true);
			if (!newSkus.length) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: "Please select atleast one Sku", severity: "error" });
				setLoadingOpen(false);
				return;
			}

			await axios
				.put(`/api/studio/bulk_create_shoot_skus/${selectedShoot[studioAttrGroupLinkedTables.shoot.key].shoot_id}`, newSkus)
				.then((res) => {
					setSelectedShootSkus((prev) => [...prev, ...res.data.result]);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "Successfully Added Skus to Shoot",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				});
			setLoadingOpen(false);
			handleSkuAddModalClose();
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};

	if (selectedShoot)
		return (
			<Box width="100%" display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
				<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1, mb: 1 }} />
				{/* top section */}
				<Box display="flex" justifyContent="space-around" width="100%">
					{/* left */}
					<Box>
						<Box width={imgWidth} height={imgHeight}>
							<ImageSlider
								imgWidth={imgWidth}
								imgHeight={imgHeight}
								column="url"
								images={selectedShoot?.[studioAttrGroupLinkedTables.shoot.key]?.[shootImagesAssocObj]}
							/>
						</Box>
						<Box p={1} pt={1} display="flex" columnGap={2}>
							<IconButton
								disabled={disableEdit}
								startIcon={<EditRounded sx={{ color: "#fff" }} />}
								sx={{
									background: "#000",
									"&: hover": { background: "#00000083" },
									// width: 100,
								}}
								variant="contained"
								onClick={() => setImgInfoModal(true)}>
								<EditRounded sx={{ color: "white" }} />
							</IconButton>
							<IconButton
								disabled={disableEdit}
								sx={{
									background: "#000",
									"&: hover": { background: "#00000083" },
								}}
								variant="contained"
								onClick={() => setAddNewImgModal(true)}>
								<AddRounded sx={{ color: "#fff" }} />
							</IconButton>
						</Box>
					</Box>
					<Divider orientation="vertical" flexItem />
					{/* right */}
					<Box sx={{ width: "76%" }}>
						{Object.keys(attrGroupsWithAttr)
							.reduce((acc, row) => {
								if (
									attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.linked_table.key] ===
									studioAttrGroupLinkedTables.shoot.key
								)
									acc.push(attrGroupsWithAttr[row]);
								return acc;
							}, [])
							?.map((row) => {
								return (
									<DisplayDetailsWithEditTab
										columns={[...row[studioAttrGrpAttrAssocObj]]}
										data={selectedShoot}
										setData={setSelectedShoot}
										attrGrp={row}
										disableEdit={true}
										updateFunction={updateDetailsFun}
										width="30%"
									/>
								);
							})}
						<Box width="100%" pt={4}>
							<Box width="100%" display="flex" justifyContent="space-between">
								<Typography variant="h6">Modal Profile</Typography>
								<Button variant="contained" disabled={disableEdit} onClick={handleModalprofileEditModalOpen}>
									Edit
								</Button>
							</Box>
							<ModalSection
								selectedModal={selectedShoot?.[studioAttrGroupLinkedTables.shoot.key]?.[shootModalProfileAssoc]}
								setSelectedModal={() => {}}
								shootDetails={selectedShoot}
								disabled={true}
								hideInput
								height={150}
							/>
						</Box>
					</Box>
				</Box>
				<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1 }} />

				{/* Shoot Details Table Columns */}
				{Object.keys(attrGroupsWithAttr)
					.reduce((acc, row) => {
						if (
							attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.linked_table.key] ===
							studioAttrGroupLinkedTables.shoot_details.key
						)
							acc.push(attrGroupsWithAttr[row]);
						return acc;
					}, [])
					?.map((row) => {
						return (
							<DisplayDetailsWithEditTab
								columns={[...row[studioAttrGrpAttrAssocObj]]}
								data={selectedShoot}
								setData={setSelectedShoot}
								attrGrp={row}
								updateFunction={updateDetailsFun}
								disableEdit={disableEdit}
							/>
						);
					})}

				<Divider sx={{ width: "100%", mt: 2 }} orientation="horizontal" />
				<ShootSkuImages
					selectedShoot={selectedShoot}
					shootSkus={selectedShootSkus}
					setShootSkus={setSelectedShootSkus}
					handleAddSkuClick={handleSkuAddModalOpen}
					disableEdit={disableEdit}
				/>
				<Divider sx={{ width: "100%", mt: 2, mb: 1 }} orientation="horizontal" />
				<AddFiles
					addNewDefault={{ [styleImgDepartmentCol.key]: departments.STUDIO.key }}
					columns={fileColumns}
					handleAddFile={handleFileAdd}
					files={selectedShoot?.[studioAttrGroupLinkedTables.shoot.key]?.[shootFileAssocObj] ?? []}
					setFiles={(files) => {
						setSelectedShoot((prev) => ({
							...prev,
							[studioAttrGroupLinkedTables?.shoot.key]: {
								...prev?.[studioAttrGroupLinkedTables.shoot.key],
								[shootFileAssocObj]: files,
							},
						}));
					}}
					handleDelete={handleFileDelete}
					handleDownload={handleFileDownload}
				/>
				{/* add Images Modal */}

				{addNewImgModal && (
					<AddNewImageModal
						modalOpen={addNewImgModal}
						setModalOpen={setAddNewImgModal}
						submitFunction={addNewImages}
						// defaultImages={selectedShoot?.[studioAttrGroupLinkedTables.shoot.key]?.[shootImagesAssocObj]}
					/>
				)}
				{imgInfoModal && (
					<EditImageDataModal
						modalOpen={imgInfoModal}
						setModalOpen={setImgInfoModal}
						submitFunction={updateMainImage}
						selectedShoot={selectedShoot}
					/>
				)}
				<Dialog fullWidth maxWidth="md" open={modalProfileEditModal} onClose={handleModalprofileEditModalClose}>
					<Box width="98%" p={2} boxSizing="border-box">
						<ModalSection
							selectedModal={editedModelProfile}
							setSelectedModal={setEditedModelProfile}
							shootDetails={selectedShoot}
						/>
					</Box>
					<DialogActions>
						<Button variant="outlined" onClick={handleModalprofileEditModalClose}>
							Cancel
						</Button>
						<Button autoFocus variant="contained" sx={{ mr: 1 }} onClick={handleUpdateModalProfileSave}>
							Save
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog fullWidth maxWidth="md" open={skuAddModal} onClose={handleSkuAddModalClose}>
					<Box width="98%" p={2} boxSizing="border-box">
						<SkuSectionTanstack
							shootData={selectedShoot}
							selectedSkus={newSkus}
							setSelectedSkus={setNewSkus}
							defaultFilterObj={{ [sampleStatusColumn.key]: selectedShootVisibleStatus }}
						/>
					</Box>
					<DialogActions>
						<Button variant="outlined" onClick={handleSkuAddModalClose}>
							Cancel
						</Button>
						<Button autoFocus variant="contained" sx={{ mr: 1 }} onClick={handleSkuAddSkuModalSave}>
							Save
						</Button>
					</DialogActions>
				</Dialog>
			</Box>
		);
	else {
		if (!Loadingopen && hasResolvedShoot)
			return (
				<Stack display="flex" justifyContent="center" alignItems="center" height="100%" spacing={1}>
					<Typography variant="h5" p={2}>
						---- No Shoot Id Found ----
					</Typography>
					<Button variant="contained" sx={{ textTransform: "capitalize" }} onClick={goToShootsPage}>
						Go to All Shoots
					</Button>
				</Stack>
			);
	}
};

export default SelectedShoot;
